// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WijC","controls":"styles_controls__2fznn","charLimit":"styles_charLimit__1bkWD","input":"styles_input__2fZWr","send":"styles_send__2PaNb"};